import { useQuery, useMutation, } from "@tanstack/react-query";
export const createCertificationsQueries = (requests, queryClient) => ({
    useListCertifications: (params, options = {}) => useQuery({
        queryKey: ["certifications", params],
        queryFn: async ({ queryKey }) => {
            const [_key, params] = queryKey;
            return requests.listCertifications(params);
        },
        ...options,
    }),
    useCreateCertification: (options = {}) => useMutation({
        ...options,
        mutationFn: requests.createCertification,
        onSuccess: (data, variables, context) => {
            queryClient.invalidateQueries({ queryKey: ["certifications"] });
            options.onSuccess?.(data, variables, context);
        },
    }),
});
//# sourceMappingURL=index.js.map